import { updateObject } from './../../utils/utility';

const initialState = {
    userList: [],
    totalElements: 0,
    pageNumber: 0,
    totalPages: 0,
    listEdited: false,
    selectedUserData: null,
    selectedUserTeams: [],
    userDetailsCallComplete: false,
    selectedUserTeamsCallComplete: false,
    searchFilter: {
        userType: "",
        value: ""
    }
};

const setUsersData = (state = initialState, action) => {
    const { userList, totalElements, pageNumber, totalPages } = action.payload;
    return updateObject(state, {
        userList: userList,
        totalElements: totalElements,
        pageNumber: pageNumber,
        totalPages: totalPages,
        listEdited: false
    }
    );
}

const setListEdited = (state = initialState) => {
    return updateObject(state, {
        listEdited: true
    });
}

const setSelectedUserData = (state = initialState, action) => {
    const data = action.payload;

    const nonCustomerUserTypes = ["Manager", "Vendor"];
    const simplifiedUserType = data.userType && nonCustomerUserTypes.includes(data.userType) ? data.userType : "Customer";

    const updatedState = updateObject(state, {
        selectedUserData: { ...data, simplifiedUserType },
        userDetailsCallComplete: true
    });
    return updatedState;
}

const setSelectedUserTeams = (state = initialState, action) => {

    const updatedState = updateObject(state, {
        selectedUserTeams: action.payload,
        selectedUserTeamsCallComplete: true
    });
    return updatedState;
}

const resetSelectedUserData = (state = initialState) => {
    const updatedState = updateObject(state, {
        selectedUserData: null,
        userDetailsCallComplete: false,
        selectedUserTeams: [],
        selectedUserTeamsCallComplete: false
    });
    return updatedState;
}

const setUserDetailsCallComplete = (state = initialState, action) => {
    return updateObject(state, {
        userDetailsCallComplete: action.data
    });
}

const setSelectedUserTeamsCallComplete = (state = initialState, action) => {
    return updateObject(state, {
        selectedUserTeamsCallComplete: action.data
    });
}

const setSpecificUserData = (state = initialState, action) => {
    const { data } = action;
    const userListCopy = [...state.userList];
    const indexOfUserBeingUpdated = userListCopy.findIndex(user => user.userId === data.userId);
    if (indexOfUserBeingUpdated !== -1 && data) {
        userListCopy[indexOfUserBeingUpdated] = data;
    }
    return updateObject(state, { userList: userListCopy });
}

const searchFilter = (state = initialState, action) => {
    return updateObject(state, { searchFilter: action.payload })
}

const reducer = (state = initialState, action) => {
    if (action.type === "SET_USERS") {
        return setUsersData(state, action);
    }
    else if (action.type === "SET_LIST_EDITED") {
        return setListEdited(state);
    }
    else if (action.type === "SET_SELECTED_USER_DATA") {
        return setSelectedUserData(state, action);
    }
    else if (action.type === "SET_SELECTED_USER_TEAMS") {
        return setSelectedUserTeams(state, action);
    }
    else if (action.type === "RESET_SELECTED_USER_DATA") {
        return resetSelectedUserData(state);
    }
    else if (action.type === "SET_USER_DETAILS_CALL_COMPLETE") {
        return setUserDetailsCallComplete(state, action);
    }
    else if (action.type === "SET_SELECTED_USER_TEAMS_CALL_COMPLETE") {
        return setSelectedUserTeamsCallComplete(state, action);
    }
    else if (action.type === "UPDATE_SPECIFIC_USER_DATA") {
        return setSpecificUserData(state, action);
    }
    else if(action.type === "SET_SEARCH_FILTER") {
        return searchFilter(state, action);
    }
    return state;
}

export default reducer;
